import { BrowserRouter, Switch, Route } from "react-router-dom";
import Login from "../components/Login/Login";
import Register from "../components/Register";
import Home from "../components/Home/Home";
import Dashboard from "../components/Dashboard/Dashboard";
import ProtectedRoute from "../Routes/ProtectedRoute";
import Mybooks from "../components/MyBooks/Mybooks";
import Book from "../components/Dashboard/Book";
import { Confirm } from "../components/Confirm/Confirm";
import Welcome from "../components/Welcome/Welcome";
import Activities from "../components/Activities/Activities";
import viewBook from "../components/Activities/viewBook";
import Error from "../components/Error";

function Routes() {
  return (
    <BrowserRouter basename="/mfbui">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/Login" component={Login} />
        <Route exact path="/Register" component={Register} />

        <Route
          component={({ match }) => (
            <Switch>
              <ProtectedRoute exact path="/Dashboard" component={Dashboard} />
              <ProtectedRoute exact path="/Mybooks" component={Mybooks} />
              <ProtectedRoute path="/Book/:id" component={Book} />
              <Route exact path="/Confirm/:id" component={Confirm} />
              <Route exact path="/Welcome" component={Welcome} />
              <Route exact path="/Activities" component={Activities} />
              <Route exact path="/viewBook" component={viewBook} />
              <Route component={Error} />
            </Switch>
          )}
        />
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;
